export default __webpack_public_path__ + "static/media/top-ten-5.e04ccb99.svg";